import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const style = {
  root: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    background: "rgba(255,255,255,.3)"
  }
}

const TopLinearLoading = ({ classes }) => <div className={classes.root}><LinearProgress/></div>

TopLinearLoading.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style)(TopLinearLoading);